import axios from "axios";

const API_TIMEOUT = 5000;
const BASE_URL = `https://4.react.pages.academy/wtw`;

const Error = {
  UNAUTHORIZED: 401
};

export const createAPI = () => {
  const api = axios.create({
    baseURL: BASE_URL,
    timeout: API_TIMEOUT,
    withCredentials: true,
  });

  const onSuccess = (response) => {
    return response;
  };

  const onFail = (err) => {
    const {response} = err;

    if (response.status === Error.UNAUTHORIZED) {
      throw err;
    }

    throw err;
  };

  api.interceptors.response.use(onSuccess, onFail);

  return api;
};
